import React, { useEffect, useRef, useState } from 'react';

interface TextTrimmerProps {
  textInput: string | null | undefined;
  linesNumber?: number | undefined;
  dir?: 'ltr' | 'rtl';
}

export const TextTrimmer: React.FC<TextTrimmerProps> = ({
  textInput,
  linesNumber = 1,
  dir = 'rtl',
}) => {
  const textContainerRef = useRef<HTMLDivElement>(null);

  const [text, setText] = useState<string[] | undefined>(textInput?.split(' '));
  const [isTrimmed, setIsTrimmed] = useState(false);

  const extractTextChild = (textContainer: HTMLElement, index: number) => {
    return textContainer.children[index] as HTMLElement;
  };

  useEffect(() => {
    const textContainer = textContainerRef.current;
    const lineHeight = textContainer?.children[0]?.clientHeight;

    if (textContainer && textInput && lineHeight) {
      const rootOffset = textContainer.offsetTop;

      const trimmedText: string[] = [];

      for (let i = 0; i <= textInput?.trim().split(' ').length - 1; i++) {
        const textChild = extractTextChild(textContainer, i);

        // When the content of the child is "", 14 is added to its offsetTop, and sometimes
        // the offsetTop is higher by 1, so these two cases are taken care of below
        if (
          textChild.offsetTop - rootOffset <= lineHeight * (linesNumber - 1) ||
          textChild.offsetTop -
            rootOffset -
            (textChild.textContent === '' ? 14 : 1) <=
            lineHeight * (linesNumber - 1)
        ) {
          trimmedText.push(textChild.textContent as string);
        }
      }

      const afterLastTextChild = textContainer.children[trimmedText.length] as
        | HTMLElement
        | undefined;

      if (
        afterLastTextChild &&
        afterLastTextChild.offsetTop - rootOffset >
          lineHeight * (linesNumber - 1)
      ) {
        const lastTrimmedText = trimmedText[trimmedText.length - 1];

        if (lastTrimmedText.length > 3) {
          const lastTrimmedTextArray = lastTrimmedText.split('');

          lastTrimmedTextArray.splice(lastTrimmedTextArray.length - 3, 3);

          trimmedText[trimmedText.length - 1] =
            lastTrimmedTextArray.join('') + '...';
        } else {
          trimmedText[trimmedText.length - 1] = '...';
        }
      }

      setIsTrimmed(true);
      setText(trimmedText);
    }
  }, [textInput, linesNumber]);

  const renderTextToTrim = (text: string[] | undefined) => {
    return text?.map((t, i) => (
      <>
        <span
          key={i}
          // className={`inline-block ${dir === 'ltr' ? 'mr-[3px]' : 'ml-[3px]'}`}
          className="inline-block"
        >
          {t}
        </span>
        &nbsp;
      </>
    ));
  };

  const renderText = (text: string[] | undefined) => {
    return text?.join(' ');
  };

  return (
    <div ref={textInput ? textContainerRef : null} className="w-full">
      {!isTrimmed
        ? renderTextToTrim(textInput ? textInput.trim().split(' ') : undefined)
        : renderText(text)}
    </div>
  );
};
